import {FC} from "react";
import {RecoilRoot, RecoilRootProps} from "recoil";

const StoreProvider: FC<RecoilRootProps> = (props) => {
    const {children, ...rest} = props;

    return (
        <RecoilRoot {...rest}>
            {children}
        </RecoilRoot>
    );
}

export default StoreProvider;
